import { VisitorMeasureDrawerControl, VisitorMeasureDrawerControlMenuItem } from './VisitorMeasureDrawerControl';
import type {
  VisitorMeasureDrawerControlMenuItemProps,
  VisitorMeasureDrawerControlProps,
} from './VisitorMeasureDrawerControl';
import { useMeasureDrawerControl } from './useMeasureDrawerControl';

export function VisitorMeasureDrawerControlWrapper(
  props: Pick<VisitorMeasureDrawerControlProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, showVisualIndicator, shouldShowButton } = useMeasureDrawerControl();

  return shouldShowButton ? (
    <VisitorMeasureDrawerControl
      {...props}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
      showVisualIndicator={showVisualIndicator}
      tooltipText={helperText}
    />
  ) : null;
}

export function VisitorMeasureDrawerControlMenuItemWrapper(
  props: Pick<VisitorMeasureDrawerControlMenuItemProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, outstandingMeasuresCount, shouldShowButton } = useMeasureDrawerControl();

  return shouldShowButton ? (
    <VisitorMeasureDrawerControlMenuItem
      {...props}
      helperText={helperText}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
      outstandingMeasuresCount={outstandingMeasuresCount}
    />
  ) : null;
}
